// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ProductBadges, { ProductBadgesStyles } from "@guestsupply/App/Components/Common/ProductBadges";
import xUseWidgetBadges from "@guestsupply/App/Hooks/xUseWidgetBadges";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";

const enum fields {
    showImageBadges = "showImageBadges",
    showTextBadges = "showTextBadges",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showImageBadges]: boolean;
        [fields.showTextBadges]: boolean;
    };
}

type Props = OwnProps & HasProductContext;

export interface ProductDetailsBadgesStyles {
    productBadgesStyles?: ProductBadgesStyles;
}

export const productDetailsBadgesStyles: ProductDetailsBadgesStyles = {};

const styles = productDetailsBadgesStyles;

const ProductDetailsBadges: FC<Props> = ({ productContext, fields: { showImageBadges, showTextBadges } }) => {
    const { ootbBadgesAndTags, customBadgesAndTags } = xUseWidgetBadges({
        productContext,
        showTextBadges,
        showImageBadges,
    });

    return (
        <ProductBadges
            ootbBadgesAndTags={ootbBadgesAndTags}
            customBadgesAndTags={customBadgesAndTags}
            extendedStyles={styles.productBadgesStyles}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(ProductDetailsBadges),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.showImageBadges,
                displayName: "Show Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showTextBadges,
                displayName: "Show Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
